import React from "react";

const ProductSpecificationCard = ({ product }) => {
    const attributes = product.attributes || [];
    
    if (attributes.length === 0) return null;

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0">PRODUCT SPECIFICATIONS</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {attributes.map((attr, index) => (
                        <div className="col-md-4 mb-2" key={index}>
                            <strong>{attr.attr_key.replace(/_/g, ' ').toUpperCase()}:</strong> {attr.attr_value}
                        </div>
                    ))}
                </div>
                </div>
        </div>
    );
};

export default ProductSpecificationCard;